export const taskLabelsLookup = {
  'provide-ssn': 'Provide SSN',
  'confirm-liens': 'Confirm Liens',
  'confirm-payoffs': 'Confirm Payoffs',
  document: 'Document',
  'provide-id-document': 'Provide ID Document',
  'provide-mortgage-statement': 'Provide Mortgage Statement',
  'complete-income': 'Complete Income',
  'complete-declarations': 'Complete Declarations',
  'complete-assets': 'Complete Assets',
  'add-co-applicant': 'Add Co-Applicant',
  'provide-rental-agreement': 'Provide Rental Agreement',
  'provide-personal-info': 'Provide Personal Info',
  'provide-home-owners-insurance-policy': 'Provide Home Owners Insurance Policy',
  'provide-trust-agreement': 'Provide Trust Agreement',
  'provide-homeowners-association-bill': 'Provide Homeowners Association Bill',
  'confirm-monthly-housing-expenses': 'Confirm Monthly Housing Expenses',
  'confirm-property-info': 'Confirm Property Info',
  'confirm-property-title': 'Confirm Property Title',
  'buyout-request': 'Buyout Request',
  'provide-appraisal-order': 'Provide Appraisal Order',
  'acknowledge-payoff-and-accept-wire-details': 'Acknowledge Payoff and Accept Wire Details',
}

export function interpolateLienInDocTemplate(doc, liens) {
  const template = doc?.request_template_message

  if (doc.name === 'Mortgage Statement - First') {
    const firstLien = liens.find((l) => l.lien_position === 1)
    return firstLien ? template.replace('{mortgage co}', firstLien?.name) : template
  }

  if (doc.name === 'Mortgage Statement - Second') {
    const secondLien = liens.find((l) => l.lien_position === 2)
    return secondLien ? template.replace('{mortgage co}', secondLien?.name) : template
  }

  if (doc.name === 'Mortgage Payoff Statement') {
    const mortageLiens = liens.filter((l) => l.account_type === 'Mortgage')
    if (mortageLiens.length > 0)
      return template.replace(
        '{mortgage co}',
        `<br><ul>${mortageLiens.map((item) => `<li>${item.name}</li>`).join('')}</ul>`
      )
  }

  return template
}
